import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "55117373ff9f6e546c5d9d897ce1fbaa.jpg","uri@2x": __webpack_public_path__ + "83e2c889dfcc05043df29c02361d9ccc.jpg","uri@3x": __webpack_public_path__ + "701f51f41980102d863aabc7077507b4.jpg",
    width: 1024,
    height: 550
});